<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      {{titolo}}
    </div>
  </mat-card-title>
  <mat-card-content>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Data Richiesta:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.DataRichiesta | date: 'dd/MM/yyyy' }}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Descrizione:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.Descrizione}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Stato Approvazione:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.DescrizioneStatoApprovazione}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Tipo Adesione:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.DescrizioneTipoAdesione}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Tipologia Richiesta:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.DescrizioneTipologiaRichiesta}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Importo:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.Importo}} €
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Cognome Nome:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.Cognome}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Periodo:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.Periodo}}
      </div>
    </div>


    <p>Intestato a "Gruppo Italiano di Idraulica", Unicredit Banca, Agenzia Politecnico, Torino (TO)</p>
    <p><strong>c/c</strong> 000102446219</p>
    <p><strong>ABI</strong> 02008</p>
    <p><strong>CIN</strong> G</p>
    <p><strong>IBAN</strong> IT63G0200801160000102446219</p>

    <button mat-raised-button color="primary" (click)="btnConfermaIlPagamento()">
      Conferma il pagamento
    </button>

  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>


